export default __webpack_public_path__ + "static/media/mousepad.6f324c87.png";